// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__20u_q","name":"ConsentHeader_name__2BVKO","birthday":"ConsentHeader_birthday__16QmI","skeleton":"ConsentHeader_skeleton__1bq6q"};